// @flow

import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { colors } from '../../style'

import DownloadIcon from './DownloadIcon'

const Root = styled.a`
  flex: 1;

  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border: 2px solid black;

  text-decoration: none;

  cursor: pointer;

  color: ${colors.black};

  &:hover {
    z-index: 3;
    color: ${colors.red};
    border-color: ${colors.red};
  }
`

const Icon = styled(DownloadIcon)`
  margin-bottom: 12px;
`

type Props = {
  href: string
};

class DownloadButton extends Component {
  props: Props;

  state = {
    hovered: false
  }

  render() {
    const { href } = this.props;

    return (
      <Root
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => { this.setState({ hovered: true }) }}
        onMouseLeave={() => { this.setState({ hovered: false }) }}
      >
        <Icon
          width="62"
          height="41"
          hovered={this.state.hovered}
        />
        <FormattedMessage id="book.controls.download" />
      </Root>
    )
  }
}

export default DownloadButton



// WEBPACK FOOTER //
// ./src/components/Book/DownloadButton.js